import React from "react";
import {cx} from "../../lib/ClassSet";
import "./UserItem.css";

const UserItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "accounts-user-list-item": true,
    "u-selected": props.selected
  })

  return (
    <li className={classes} onClick={(e) => props.onClick(data, e)}>
      <div className="field f-id">{data.get("userId")}</div>
      <div className="field f-name">{data.get("name")}</div>
      <div className="field f-status">{data.get("status")}</div>
    </li>
  )
}

export default UserItem;